var map = {
	"./placeholder-artist.svg": "fdb7",
	"./placeholder-card.svg": "9a15",
	"./placeholder-company.svg": "3e79",
	"./placeholder-event.svg": "6a7f",
	"./placeholder-gallery.svg": "f7c2",
	"./placeholder-genre.svg": "cf0e",
	"./placeholder-info.svg": "e711",
	"./placeholder-notification.svg": "0337",
	"./placeholder-ticket.svg": "6d9a",
	"./placeholder-user.svg": "584a",
	"./placeholder-users.svg": "62fc",
	"./placeholder-venue.svg": "5013"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e220";